<template>
  <div class="ace-paper-cont clear-mrg">
    <div class="padd-box">

      <section class="section clear-mrg">
        <h2 class="title-lg text-upper">就职</h2>

        <div class="padd-box-sm clear-mrg">
          <div class="ref-box brd-btm hreview">
            <div class="ref-avatar">
              <img alt="" src="/static/img/uploads/avatar/avatar-54x54-01.png" class="avatar avatar-54 photo" height="54"
                width="54">
            </div>

            <div class="ref-info">
              <div class="ref-author">
                <strong>马云</strong>
                <span>天猫，支付宝</span>
              </div>

              <blockquote class="ref-cont clear-mrg">
                <p>Your brand is the core of your marketing, the central
                  theme around your products and services.Your brand is not
                  your Logo or your Company Name
                </p>
              </blockquote>
            </div>
          </div><!-- .ref-box -->

          <div class="ref-box brd-btm hreview">
            <div class="ref-avatar">
              <img alt="" src="/static/img/uploads/avatar/avatar-54x54-02.png" class="avatar avatar-54 photo" height="54"
                width="54">
            </div>

            <div class="ref-info">
              <div class="ref-author">
                <strong>刘强东</strong>
                <span>京东购物</span>
              </div>

              <blockquote class="ref-cont clear-mrg">
                <p>Your brand is the core of your marketing, the central
                  theme around your products and services.Your brand is not
                  your Logo or your Company Name
                </p>
              </blockquote>
            </div>
          </div><!-- .ref-box -->

          <div class="ref-box brd-btm hreview">
            <div class="ref-avatar">
              <img alt="" src="/static/img/uploads/avatar/avatar-58x58-default.png" class="avatar avatar-54 photo" height="54"
                width="54">
            </div>

            <div class="ref-info">
              <div class="ref-author">
                <strong>马化腾</strong>
                <span>腾讯QQ，微信</span>
              </div>

              <blockquote class="ref-cont clear-mrg">
                <p>Your brand is the core of your marketing, the central
                  theme around your products and services.Your brand is not
                  your Logo or your Company Name
                </p>
              </blockquote>
            </div>
          </div><!-- .ref-box -->


        </div><!-- .padd-box-sm -->
      </section><!-- .section -->

      <section class="section clear-mrg">
        <h2 class="title-lg text-upper">产品</h2>
        <div class="padd-box-sm">
          <ul class="clients">
            <li><a href=""><img src="/static/img/uploads/logos/logo-wordpress.png" alt="WordPress"></a></li>
            <li>
              <a href=""><img src="/static/img/uploads/logos/logo-compass.png" srcset="/static/img/uploads/logos/logo-compass2x.png 2x"
                  alt="Compass"></a>
            </li>
            <li>
              <a href=""><img src="/static/img/uploads/logos/logo-jquery.png" srcset="/static/img/uploads/logos/logo-jquery2x.png 2x"
                  alt="jQuery"></a>
            </li>
            <li>
              <a href=""><img src="/static/img/uploads/logos/logo-teaspoon.png"
                  srcset="/static/img/uploads/logos/logo-teaspoon2x.png 2x" alt="teaspoon"></a>
            </li>
            <li>
              <a href=""><img src="/static/img/uploads/logos/logo-evernote.png"
                  srcset="/static/img/uploads/logos/logo-evernote2x.png 2x" alt="evernote"></a>
            </li>
            <li>
              <a href=""><img src="/static/img/uploads/logos/logo-bootstrap.png"
                  srcset="/static/img/uploads/logos/logo-bootstrap2x.png 2x" alt="Bootstrap"></a>
            </li>
          </ul>
        </div><!-- .padd-box-sm -->
      </section><!-- .section -->
    </div><!-- .padd-box -->

    <!-- END: PAGE CONTENT -->

  </div><!-- .ace-paper-cont -->
</template>

<script>
  export default {
    name: 'testimonials',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/testimonials.vue